module.exports = __webpack_public_path__ + "static/media/reliso.96624efd.mp3";